<template>
  <label for="services-multiselect-component" class="form-label">
    {{ $t('service.list') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedServices"
    :options="{
      create: false,
      placeholder: $t('service.selectMore')
    }"
    class="w-full"
    multiple
  >
    <option v-for="service in services" :value="service.uuid" :key="service.uuid">
      {{ service.name.sk_SK }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import serviceApi from '../../services/services/service.api'

export default defineComponent({
  data() {
    return {
      services: []
    }
  },
  mounted() {
    serviceApi.getList(1, 1000).then(
      (response) => {
        this.services = response.data.data
      },
      (error) => {
        alert(error)
      }
    )
  },
  props: {
    selectedServices: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedServices'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedServices,
      set: (value) => emit('update:selectedServices', value)
    })

    return {
      componentValue
    }
  }
})
</script>
